import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs, useRequestData } from 'wsm-common-data';

import TabsControls from './TabsControls';
import TabTitle from './TabTitle';

const Tabs = React.forwardRef(({ children, id, onSelect, activeKey }, ref) => {
	const { displayStyle, tabsAlignment, isFragmentPage } = usePrefs();
	const { deviceType } = useRequestData();
	const isCarousel = displayStyle === 'carousel' && deviceType !== 'MOBILE';

	const tabsClassNames = setClassNames([
		'nav',
		'nav-pills',
		'tabs-container',
		tabsAlignment,
		isCarousel ? 'carousel' : null,
		isFragmentPage === 'true' ? 'model-selector-fragment' : null
	]);

	const activeChildren = children.find(
		(_child) => _child.props.eventKey === activeKey
	);

	return (
		<div id={id} className="tabs">
			<TabsControls tabSliderRef={ref} />

			<div ref={ref} role="tablist" className={tabsClassNames}>
				{React.Children.toArray(
					children.map((_tab, _index) => {
						const { title, eventKey } = _tab.props;
						const isActiveTab = activeKey === eventKey;
						return (
							<TabTitle
								id={id}
								tabIndex={0}
								title={title}
								onSelect={onSelect}
								eventKey={eventKey}
								isActive={isActiveTab}
							/>
						);
					})
				)}
			</div>

			<div className="tab-content">
				{React.cloneElement(activeChildren, {
					parentId: id
				})}
			</div>
		</div>
	);
});

Tabs.propTypes = {
	id: PropTypes.string,
	onSelect: PropTypes.func,
	activeKey: PropTypes.string,
	children: PropTypes.arrayOf(PropTypes.element)
};

export default Tabs;
